import React from "react"

type PorematLogoProps = {
  className?: string
}

const logoPath = "/assets/logo.png"

export const PorematLogo: React.FC<PorematLogoProps> = ({ className = "" }) => {
  return (
    <div className="flex items-center space-x-2">
      <img src={logoPath} alt="Poremat Logo" className={className} />
    </div>
  )
}
